// extracted by mini-css-extract-plugin
export default {"optionLabel":"SelectUsers_optionLabel__lS54n"};